import Link from 'next/link'
import { useRouter } from 'next/router'
import React from 'react'

import { S05 } from '../../../../styles/typography'
import { UpcomingEl } from '../elements/upcoming'
import CourseHomeStore from '../stores/course-home-store'

const Banner = () => {
  const {
    query: { livdemyId },
  } = useRouter()

  const {
    data: { artist, upcomingQna = [] },
  } = CourseHomeStore.useContainer()

  return upcomingQna.map((qna) => (
    <UpcomingEl>
      <div className='container'>
        <S05>
          Sign up for the upcoming Live, interactive Q&A Session with{' '}
          <Link href={`/${livdemyId}`} passHref>
            <span>{artist}</span>
          </Link>
          . Free for Certification course students. Click here to&nbsp;
          <Link href={`/${livdemyId}/qna/${qna.url}`} passHref>
            <span style={{ display: 'inline-block' }}>register.</span>
          </Link>
        </S05>
      </div>
    </UpcomingEl>
  ))
}

export default Banner
